import ChatView from '@frontend/ui/features/chat/views/ChatView.vue';

const routes = [
  {
    name: 'chat-view',
    path: '/advisor/chat',
    component: ChatView,
  },
];

export default routes;
